import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import moment from "moment";
import toast from "react-hot-toast";
import api from "../../api/axios";

const ReturnAssetModal = ({
  isVisible,
  onClose,
  asset,
  employeeId,
  onAssetReturned,
}) => {
  const [returnDate, setReturnDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleReturnDateChange = (e) => {
    setReturnDate(e.target.value);
    if (moment(e.target.value).isBefore(moment(asset.assigned_date))) {
      setError("Return date cannot be earlier than the assigned date.");
    } else {
      setError("");
    }
  };

  const handleReturnAsset = () => {
    setLoading(true);
    api
      .put(`return-asset/${asset.id}?employee_id=${asset?.employee_id}`, {
        return_date: moment(returnDate).format("YYYY-MM-DD"),
        updated_by: employeeId,
      })
      .then((res) => {
        toast.success("Asset taken back successfully.");
        onAssetReturned();
        onClose();
      })
      .catch((err) => {
        console.error(err);
        onClose();
        toast.error("Failed to return asset. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={isVisible} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Confirm Asset Return</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please confirm the return of this asset by the employee and select the
          return date.
        </p>

        <Form>
          <Form.Group controlId="returnDate">
            <Form.Label>Return Date:</Form.Label>
            <Form.Control
              type="date"
              value={returnDate}
              onChange={handleReturnDateChange}
              min={
                asset ? moment(asset.assigned_date).format("YYYY-MM-DD") : ""
              }
            />
            {error && <Form.Text className="text-danger">* {error}</Form.Text>}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        {/* Add loading claass so loader show */}
        <Button
          variant="primary"
          onClick={handleReturnAsset}
          disabled={!returnDate || loading || error}
        >
          {loading ? "Confirming..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReturnAssetModal;
